import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-notification-cart',
    imports: [CommonModule, RouterModule],
    templateUrl: './notification-cart.component.html',
    styleUrl: './notification-cart.component.scss'
})
export class NotificationCartComponent {



}
